
document.addEventListener('DOMContentLoaded', function () {

  // --- Fade-in en cascade ---
  const sections = document.querySelectorAll('.shopify-section');

  sections.forEach(function (section, index) {
    section.classList.add('fade-in-section');
    section.style.transitionDelay = (index * 0.15) + 's';
  });

  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.fade-in-section').forEach(function (el) {
    observer.observe(el);
  });

  // --- Curseur patte ---
  const cursor = document.createElement('div');
  cursor.classList.add('custom-cursor');
  cursor.innerHTML = '🐾';
  document.body.appendChild(cursor);

  document.addEventListener('mousemove', function (e) {
    cursor.style.left = e.clientX + 'px';
    cursor.style.top = e.clientY + 'px';
  });

  document.querySelectorAll('a, button, .product-card, .card').forEach(function (el) {
    el.addEventListener('mouseenter', function () {
      cursor.classList.add('is-hovering');
    });
    el.addEventListener('mouseleave', function () {
      cursor.classList.remove('is-hovering');
    });
  });
    // --- Header transparent → opaque ---
  const header = document.querySelector('.header-wrapper');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    });
  }

});


